import { Subject } from 'rxjs';





export class HTML5Navigator {

    static _instance: HTML5Navigator;
    static get instance(): HTML5Navigator {
        if (!this._instance)
            this._instance = new HTML5Navigator();
        return this._instance;
    }


    private navigationSubject: Subject<any>;
    public navigationEvent;

    constructor() {
        this.navigationSubject = new Subject<any>();
        this.navigationEvent = this.navigationSubject.asObservable();
        this.hookHistory();
    }

    destructor() {
        this.navigationSubject.complete();
    }

    private getHost() {
        return `${location.protocol}//${location.host}`;
    }

    public navigate(state, title, url) {
        window.history.pushState(state, title, this.getHost() + '/' + url);
    }

    private hookHistory() {
        const pushState = history.pushState;
        window.history.pushState = (data, title, url) => {
            this.navigationSubject.next({ data, url });
            return pushState.apply(history, [data, title, url]);
        }
        window.onpopstate = ev => {
            this.navigationSubject.next({ data: ev.state, url: location.href });
        };
    }

}